<template>
  <div class="dataForm" >
    <div v-if="mode === 'approval' && approvalTitle" class="approval-form-title">{{ approvalTitle }}</div>
    <el-form
    ref="dataForm"
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    label-width="100px"
    class="mb-20"
    :disabled="mode === 'approval'"
    >
      <div class="underlineForm">
        <el-form-item label="客户订单号" prop="customerNo" :class="{ 'is-approval-diff': isFieldDiff('customerNo') }">
          <el-input v-model="ruleForm.customerNo" type="input" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="客户公司名称" prop="customerCompanyId" :class="{ 'is-approval-diff': isFieldDiff('customerCompanyId') }">
          <el-select :filterable="true" v-model="ruleForm.customerCompanyId" class="filter-item" placeholder="输入关键字搜索" clearable remote @focus="companyRemoteMethod('')" :remote-method="query => companyRemoteMethod(query)">
            <template v-if="companyOption.length">
              <el-option
                v-for="item in companyOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                :disabled="item.disable"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="titleId" :class="{ 'is-approval-diff': isFieldDiff('titleId') }">
          <el-select :filterable="true" v-model="ruleForm.titleId" class="filter-item" placeholder="输入关键字搜索" clearable remote :remote-method="getTitleOptionRemote" @focus="getTitleOptionRemote('')" @change="handleCompanyTitleChange">
            <template v-if="titleOption.length">
              <el-option
                v-for="item in titleOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="税率" prop="taxRate" :class="{ 'is-approval-diff': isFieldDiff('taxRate') }">
          <el-select :filterable="true" v-model="ruleForm.taxRate" class="filter-item" placeholder="输入关键字搜索" clearable @change="handleCalcTotal">
            <template v-if="taxRateList.length">
              <el-option
                v-for="item in taxRateList"
                :key="item"
                :label="item + '%'"
                :value="item"
              />
            </template>
            <el-option v-else :value="-1" disabled>暂无数据</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单图片" prop="pictures" class="fullWidth" :class="{ 'is-approval-diff': isFieldDiff('pictures') }">
           <ZUpload @changed="handleUploadChange" :value="ruleForm.pictures" :option="{ config: {} }" accept=".pdf,.jpeg,.jpg,.png,.webp"/>
        </el-form-item>
        <el-form-item label="备注" prop="mark" class="fullWidth" :class="{ 'is-approval-diff': isFieldDiff('mark') }">
          <el-input v-model="ruleForm.mark" type="textarea" class="filter-item" clearable></el-input>
        </el-form-item>
        <div class="mb-20 fullWidth" v-if="mode !== 'approval'">
          <el-button @click="handleAddBusinessComand" type="primary" >
            添加业务
          </el-button>
          <el-button @click="removeBusiness" >
            移除业务
          </el-button>
        </div>
        <el-table
          v-if="mode !== 'approval'"
          :data="ruleForm.details"
          border
          fit
          row-key="id"
          class="fullWidth"
          :summary-method="getSummaries"
          show-summary
          :header-cell-style="{ background: '#ddd', color: 'rgba(0,0,0,0.9)' }"
          @selection-change="handleTableSelect"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column prop="no" label="业务编号" width="150"/>
          <el-table-column prop="name" label="业务名称" width="100"/>
          <el-table-column prop="brand" label="业务品牌" width="100"/>
          <el-table-column prop="model" label="型号" width="100"/>
          <el-table-column prop="serial" label="序列号" width="130"/>
          <el-table-column prop="amount" label="数量" width="70"/>
          <template v-if="ruleForm.taxRate">
            <el-table-column prop="price" label="单价(含税)" width="160">
              <template #default="{ row }">
                <el-input-number v-model="row.price" type="number" @input='handleCalcTotal' :precision="2" controls-position="right"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="priceWithRate" label="单价(未税)" min-width="90" align="right">
              <template #default="{ row }">
                <span>{{ priceWithoutRate(row.price, row.amount, true)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="总价(含税)" min-width="90" align="right">
              <template #default="{ row }">
                <span>{{ numberTimes(row.price, row.amount, true)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalPriceWithRate" label="总价(未税)" min-width="90" align="right">
              <template #default="{ row }">
                <span>{{ totalPriceWithoutRate(row.price, row.amount, true)}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column prop="price" label="单价" min-width="160">
              <template #default="{ row }">
                <el-input-number v-model="row.price" type="number" :precision="2" controls-position="right"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="总价(RNB)" min-width="90" align="right">
              <template #default="{ row }">
                <span>{{ numberTimes(row.price, row.amount, true)}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </el-form>
    <div>
      <slot name="approval"/>
    </div>
    <div class="dialog-footer mt-20 " v-if="mode !== 'approval'">
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t("table.confirm") }}
      </el-button>
    </div>
    <el-dialog
      v-if="dialogVisible"
      v-model="dialogVisible"
      title="业务列表"
      width="80%"
      :before-close="handleClose"
    >
      <BusinessList mode="table" ref="BusinessList" :customerCompanyId="ruleForm.customerCompanyId" :excludeIds="getexcludeIds()" pageType="ORDER"/>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button
            type="primary"
            @click="addBusiness"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref, watch } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'
import { getTicketTitleDetailById } from '@/apis/TicketTitle'
import { getDetailById } from '@/apis/Dictionary'

import { ElMessage, ElForm, ElMessageBox } from 'element-plus'
import { createOrder, updateOrder } from '@/apis/order'

import BusinessList from './BusinessListDialog.vue'
import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'
import $number from 'number-precision'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate, handleCalcTotal } from '@/utils/index'
import { isFieldChanged } from '@/utils/approvalDiff'
import $currency from 'currency.js'
import ZUpload from '@/components/common/ZUpload.vue'

export default defineComponent({
  components: {
    BusinessList,
    ZUpload
  },
  props: {
    id: { type: Number, required: false, default: 0 },
    dialogFormVisible: { type: Boolean, required: true },
    api: { type: String, required: true },
    handleResolveTempData: { type: Function, required: false },
    selectionBusiness: { type: Array, required: false, default: () => [] },
    from: { type: String, required: false, default: 'quotation' },
    selectcCustomerCompanyId: { type: [String, Number], required: false, default: '' },
    mode: { type: String, required: false, default: '' },
    marketingFee: { type: Boolean, required: false, default: false },
    fromFieldData: { type: Object, required: false },
    compareData: { type: Object, required: false, default: null },
    approvalTitle: { type: String, required: false, default: '' }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref(ElForm)
    const BusinessList = ref({})

    const dataMap = reactive({
      from: props.from,
      mode: props.mode,
      submitLoading: false,
      ruleForm: {
        titleId: '',
        taxRate: 0,
        customerCompanyId: '' as any,
        customerNo: '',
        pictures: [] as any,
        mark: '',
        details: []
      },
      rules: {
        customerNo: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        titleId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        taxRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        customerCompanyId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: [],
        pictures: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      titleOption: [],
      companyOption: [],
      dialogVisible: false,
      selectBusinessList: [],
      taxRateList: [],
      excludeIds: [],

      isFieldDiff(fieldKey: string) {
        if (props.mode !== 'approval' || !props.compareData) {
          return false
        }
        return isFieldChanged(props.fromFieldData || dataMap.ruleForm, props.compareData, fieldKey)
      },
      handleCompanyTitleChange(value: any, keepTaxRate?: boolean) {
        dataMap.taxRateList = []
        if (value) {
          getTicketTitleDetailById(value).then((res: any) => {
            dataMap.taxRateList = res.taxRate
            if (!keepTaxRate) {
              dataMap.ruleForm.taxRate = dataMap.taxRateList[0] as any
            }
            dataMap.handleCalcTotal()
          })
        }
      },
      handleTableSelect(selection: any) {
        dataMap.selectBusinessList = selection
      },
      companyRemoteMethod: debounce((query: string | number, overrideCompanyId?: string | number) => {
        const companyIds = overrideCompanyId || props.selectcCustomerCompanyId || dataMap.ruleForm.customerCompanyId || ''
        getPageList('customerCompany/dropdown', { name: query, ids: companyIds }).then((res: any) => {
          dataMap.companyOption = res
            ? res.map((k: any) => {
              return {
                ...k,
                name: k.name || k.mark,
                disable: !k.salesManId,
                id: k.id
              }
            })
            : []
        })
      }, 500),
      getTitleOptionRemote: debounce((query: string | number, defaultVal?: boolean) => {
        getPageList(`ticketTitle/dropdown?name=${query}`).then((res: any) => {
          dataMap.titleOption = res || []
          if (defaultVal) {
            dataMap.ruleForm.titleId = dataMap.ruleForm.titleId || (dataMap.titleOption.length ? dataMap.titleOption[0].id : '')
            dataMap.handleCompanyTitleChange(dataMap.ruleForm.titleId)
          }
        })
      }, 500),
      handleAddBusinessComand() {
        if (!dataMap.ruleForm.customerCompanyId) {
          return ElMessage.error('请先选择客户公司名称！')
        }
        dataMap.dialogVisible = true
      },
      getexcludeIds() {
        dataMap.excludeIds = dataMap.ruleForm.details.map((k: any) => {
          return k.businessId
        })
        return dataMap.excludeIds
      },
      addBusiness(array: any) {
        let tempArray = array && array.length ? array : (BusinessList.value as any).selectionArray
        tempArray = dataMap.ruleForm.details.concat(tempArray)
        dataMap.ruleForm.details = (tempArray || []).map((item: any) => {
          return {
            ...item,
            businessId: item.businessId || item.id,
            name: item.name,
            price: item.price || 0
          }
        })
        // 创建订单默认业务报价的公司
        const businessIds = dataMap.ruleForm.details.map(k => k.businessId)
        getPageList(`quotation/actions/quotationTitles/${businessIds.join()}`).then(res => {
          if (res && res.length) {
            dataMap.getTitleOptionRemote('')
            dataMap.ruleForm.titleId = res[0].titleId
            dataMap.handleCompanyTitleChange(dataMap.ruleForm.titleId)
            dataMap.ruleForm.taxRate = res[0].taxRate
          }
        })
        // 新增业务时默认回填业务上一次报价的价格，编辑过的不覆盖
        getPageList(`quotation/actions/businessQuotation?businessIds=${businessIds.join()}`).then(res => {
          if (res && res.length) {
            dataMap.ruleForm.details = dataMap.ruleForm.details.map((item: any) => {
              const tempLastPrice = res.find((k: any) => k.businessId === item.businessId) || {}
              const lastPrice = tempLastPrice.lastPrice ? tempLastPrice.lastPrice : 0
              return {
                ...item,
                price: item.price || lastPrice
              }
            })
          }
        })
        dataMap.dialogVisible = false
      },
      removeBusiness() {
        if (!dataMap.selectBusinessList.length) {
          return ElMessage.error('请选择需要移除的业务！')
        }
        dataMap.ruleForm.details = dataMap.ruleForm.details.filter((k: any) => {
          return !dataMap.selectBusinessList.find(j => j.businessId === k.businessId)
        })
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const tempData = dataMap.ruleForm
              const { details } = dataMap.ruleForm
              for (let i = 0; i < details.length; i++) {
                const item = details[i]
                if (item.price === 0) {
                  ElMessageBox.confirm(
                    `是否确定${item.businessName || item.name}业务报价为0元？`,
                    '提示',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      cancelButtonClass: 'el-button--danger'
                    }
                  ).then(() => {
                    dataMap.handleSubmitFun(tempData)
                  })
                  return
                }
              }
              dataMap.handleSubmitFun(tempData)
            } catch (err:any) {
              console.log(err, 'err')
              dataMap.submitLoading = false
              if (err && err.errors) {
                err.errors.forEach((item: any) => {
                  const field = dataMap.rules[item.field][0]
                  if (field) {
                    field.message = null
                    nextTick(() => {
                      field.message = item.defaultMessage
                    })
                  }
                })
              }
            }
          }
        })
      },
      async handleSubmitFun(tempData: any) {
        const formSate = !props.id ? 'add' : 'edit'
        let result = null
        if (formSate === 'add') {
          result = await createOrder(tempData)
        } else {
          result = await updateOrder(props.id, tempData)
        }
        dataMap.submitLoading = false
        context.emit('update:visibel')
        context.emit('submit', result)
        ElMessage({
          message: !props.id ? '创建成功' : '已经提交申请，请等待审批！',
          type: 'success',
          duration: 2000
        })
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),
      priceWithoutRate: (price: any, amount: any, isCurrency: boolean) => priceWithoutRate(price, isCurrency, dataMap.ruleForm.taxRate),
      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean) => totalPriceWithoutRate(price, amount, isCurrency, dataMap.ruleForm.taxRate),
      handleCalcTotal: () => {
        dataMap.ruleForm.details = handleCalcTotal(dataMap.ruleForm.details, dataMap.ruleForm.taxRate, 'price', 'amount')
      },
      getSummaries(param: any) {
        const { columns, data } = param
        const sums: string[] = []
        columns.forEach((column: any, index: number) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map((item: any) => Number(item[column.property]))
          if (['totalPrice', 'totalPriceWithRate'].includes(column.property) && !values.every((value: any) => Number.isNaN(value))) {
            const sumNum = `${values.reduce((prev: any, curr: any) => {
              const value = Number(curr)
              if (!Number.isNaN(value)) {
                return $number.plus(prev, curr)
              }
              return prev
            }, 0)}`
            sums[index] = ['totalPrice', 'totalPriceWithRate'].includes(column.property) ? $currency(sumNum).toString() : sumNum.toString()
          } else {
            sums[index] = ''
          }
        })
        return sums
      },
      handleData(res: any) {
        if (!res) return
        dataMap.handleCompanyTitleChange(res.titleId, true)
        if (res.customerCompanyId) {
          dataMap.companyRemoteMethod('', res.customerCompanyId)
        }
        dataMap.ruleForm = { ...res, pictures: res.pictures || [] }
        dataMap.ruleForm.details = res.details
          ? res.details.map((k: any) => {
            return {
              ...k,
              name: k.name,
              id: k.businessId,
              totalPrice: dataMap.numberTimes(k.price, k.amount, true),
              totalPriceWithRate: dataMap.totalPriceWithoutRate(k.price, k.amount, true)
            }
          })
          : []
      },
      handleUploadChange(val: any) {
        dataMap.ruleForm.pictures = val || []
      }
    })
    onMounted(() => {
      dataMap.companyRemoteMethod('')
      // 只在新增模式下设置默认值，编辑/审批模式只加载选项
      const needDefault = !props.id && props.mode !== 'approval'
      dataMap.getTitleOptionRemote('', needDefault)
      if (props.id && props.mode !== 'approval') {
        getDetailById(props.api, props.id, { marketingFee: props.marketingFee, editInfo: true }).then((res: any) => {
          dataMap.handleData(res)
        })
      }
      if (props.mode === 'approval') {
        dataMap.handleData(props.fromFieldData)
      }
      if (props.selectionBusiness.length) {
        dataMap.addBusiness(props.selectionBusiness)
        dataMap.ruleForm.customerCompanyId = Number(props.selectcCustomerCompanyId)
      }

      dataMap.clearValidate()
    })

    watch(() => props.fromFieldData, (val) => {
      if (props.mode === 'approval' && val) {
        dataMap.handleData(val)
      }
    })

    return { t, ...toRefs(dataMap), dataForm, BusinessList }
  }
})
</script>
<style lang="scss" scoped>
.approval-form-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--ink, #1e293b);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--border-color, #e2e8f0);
}

:deep(.el-form-item.is-approval-diff) {
  .el-form-item__label {
    color: #E74228 !important;
    font-weight: 700 !important;
  }
  .el-input__inner,
  .el-textarea__inner,
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner,
  .el-select .el-input.is-disabled .el-input__inner {
    color: #E74228 !important;
    -webkit-text-fill-color: #E74228 !important;
    font-weight: 700 !important;
    border-color: #E74228 !important;
    background-color: rgba(231, 66, 40, 0.06) !important;
  }
}
</style>
